import { RANKING_V2_PAGE } from 'constants/testsIds/rankingV2Page';
import { JSX } from 'react';
import RankingListWrapper from './rankingsListStyles';

interface RankingsListProps {
  children: JSX.Element[] | JSX.Element;
}

const RankingsList = ({ children }: RankingsListProps) => (
  <RankingListWrapper data-cy={RANKING_V2_PAGE.RANKING_LIST}>{children}</RankingListWrapper>
);

export default RankingsList;
